import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class Company {
    public id = ''
    public name = ''

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
        })
    }
}
